import { BandConfigurationOption } from '@beatgig/api-services'

// const DefaultBandConfigurations = Object.values(BandConfigurationOption)
const DefaultBandConfigurations: BandConfigurationOption[] = []

export default DefaultBandConfigurations
